<p-blockui [blocked]="loadingService.state().isLoading" [styleClass]="'custom-loading-overlay'">
  <div class="loading-content">
    <p-progressSpinner class="custom-spinner" strokeWidth="4" />
    <p class="loading-message">{{ loadingService.state().message }}</p>
  </div>
</p-blockui>
